export default "__VITE_ASSET__XHY53y$O__"